<template>
  <div class="gf_global-style">
    <ListPreset />
    <div v-if="isCallingApi" class="gf-overlay-loading" :style="{ width: overlayWidth }"></div>
    <div class="variables-gs-color" v-html="variablesColorStyle"></div>
  </div>
</template>

<script>
import ListPreset from './ListPreset';
import { mapState } from 'vuex';
import { $JQuery } from '@/plugins';
import { app } from '@/store';
import { globalStyleService } from '@/services';
import { elementTypes, moduleTypes, rowTypes } from '@/app/editor/sidebar/constant';

export default {
  name: 'GlobalStyle',
  components: {
    ListPreset,
  },
  data() {
    return {
      overlayWidth: '290px',
    };
  },
  computed: {
    ...mapState('sidebar', {
      isCallingApi: 'isCallingApi',
      variablesColorStyle: 'variablesColorStyle',
    }),
  },
  created() {
    window.addEventListener('resize', this.onResizeWindow);

    /**
     * Revert the style after apply global style
     * @see https://app.clickup.com/t/2j4kr6p
     */
    window.revertGlobalStyle = function (isUnlinkPreset = false) {
      const vuexStore = app.$store.state;
      if (isUnlinkPreset) {
        globalStyleService.unlinkPresetFromPage({
          pageId: vuexStore.app.pageInfo.page.g_id,
          presetId: vuexStore.app.pageInfo.page.preset_id,
        });
      } else {
        const $ = $JQuery;
        const $gfFrame = $JQuery('#gfFrame');
        const $gryffBody = $gfFrame.contents().find('body').first();

        const columnStyleContainer = $gryffBody.find('#column-style-container');
        const rowStyleContainer = $gryffBody.find('#row-style-container');
        const moduleStyleContainer = $gryffBody.find('#module-style-container');
        const elementStyleContainer = $gryffBody.find('#element-style-container');

        columnStyleContainer.children().each((_, element) => {
          const elementId = element.id.slice(6);
          const bkStyle = vuexStore.editor.dataSettings[rowTypes._bkStyleColumn + '-' + elementId];
          vuexStore.editor.dataSettings[rowTypes._styleColumn + '-' + elementId] = bkStyle;

          $(element).find('.style').html(bkStyle);
        });

        rowStyleContainer.children().each((_, element) => {
          const elementId = element.id.slice(6);
          const bkStyle = vuexStore.editor.dataSettings[rowTypes._bkStyleRow + '-' + elementId];
          if (bkStyle) {
            vuexStore.editor.dataSettings[rowTypes._styleRow + '-' + elementId] = bkStyle;
            $(element).find('.style').html(bkStyle);
          }
        });

        moduleStyleContainer.children().each((_, element) => {
          const elementId = element.id.slice(6);
          const bkStyle = vuexStore.editor.dataSettings[moduleTypes._bkStyleModule + '-' + elementId];
          vuexStore.editor.dataSettings[moduleTypes._styleModule + '-' + elementId] = bkStyle;

          $(element).find('.style').html(bkStyle);
        });

        elementStyleContainer.children().each((_, element) => {
          const elementId = element.id.slice(6);
          const bkStyle = vuexStore.editor.dataSettings[elementTypes._bkStyleElement + '-' + elementId];
          vuexStore.editor.dataSettings[elementTypes._styleElement + '-' + elementId] = bkStyle;

          $(element).find('.style').html(bkStyle);
        });

        $gryffBody.find('.gf_gs-global-style').remove();
      }
    };
  },
  unmounted() {
    window.removeEventListener('resize', this.onResizeWindow);
  },
  methods: {
    onResizeWindow() {
      this.overlayWidth = window.innerHeight <= 1300 ? '260px' : '290px';
    },
  },
};
</script>

<style scoped lang="scss">
.gf_global-style {
  height: 100%;
}

.gf-overlay-loading {
  display: block !important;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999999;
  height: 100%;
  cursor: not-allowed;
}
</style>
